module.exports = {"650121001":"清水泉片区管委会街道","650121002":"谢家沟片区管委会街道","650121100":"水西沟镇","650121102":"板房沟镇","650121103":"永丰镇","650121207":"萨尔达坂乡","650121208":"甘沟乡","650121213":"托里乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650121.json
// module id = 3196
// module chunks = 0